
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="min-h-screen flex items-center justify-center relative bg-gradient-to-br from-gray-50 to-white">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-5"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/12c0731957313767f5a52bbfe0893bbe.jpg')`
        }}
      />
      
      <div className="container mx-auto px-6 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-extrabold text-black mb-8 leading-tight tracking-wide opacity-0 animate-[heroSlogan_0.7s_ease-out_0.2s_forwards]">
            Execute<span className="text-[#D4A5A5]">,</span>
            <br />
            <span className="text-[#888888]">Not Just</span> Sell.
          </h1>
          
          <p className="text-2xl md:text-3xl text-[#666666] mb-16 font-light max-w-2xl mx-auto leading-relaxed opacity-0 animate-[fadeInUp_0.8s_ease-out_0.5s_forwards]">
            브랜드 발굴부터 글로벌 유통까지, 실행의 전 과정
          </p>
          
          <Link 
            to="/about"
            className="inline-flex items-center bg-black text-white px-12 py-4 hover:bg-gray-800 transition-colors duration-300 text-lg font-medium whitespace-nowrap cursor-pointer group opacity-0 animate-[fadeInUp_0.8s_ease-out_0.8s_forwards]"
          >
            About 
            <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform duration-300"></i>
          </Link>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
      </div>
    </section>
  );
};

export default HeroSection;
